module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Part I")])])]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('span', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/01-post-investigates_woodbern_epub.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "figcaption",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n\tBob Woodward (left) and Carl Bernstein in the Washington Post newsroom. ("), _c('em', [_vm._v("Image by Ken Feil/The Washington Post)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-473db1b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap75828.vue
// module id = 69
// module chunks = 0